import * as ViewerCache from '../utils/ViewerCache';
export const configureViewerCacheMiddleware = actionType => () => next => action => {
  if (action.type === actionType) {
    var _action$payload;
    const payload = typeof ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.toJS) === 'function' ? action.payload.toJS() : action.payload;
    ViewerCache.set(payload);
  }
  return next(action);
};